import { render } from "./EmailOptInResults.vue?vue&type=template&id=25311c39&scoped=true"
import script from "./EmailOptInResults.vue?vue&type=script&lang=js"
export * from "./EmailOptInResults.vue?vue&type=script&lang=js"

import "./EmailOptInResults.vue?vue&type=style&index=0&id=25311c39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25311c39"]])

export default __exports__